import ScrollOut from 'scroll-out';
import { onDocumentReady } from '../utils/events';

/**
 * Reveal-on-scroll. Elements marked with `data-scroll` + a boilerplate
 * animation class (fade-in, ease-btm, ease-left, ...) get `data-scroll="in"`
 * once they enter the viewport. The animation CSS is desktop-only (>=1200px),
 * so smaller screens render everything immediately.
 *
 * Anything already within the initial viewport on load is shown instantly with
 * no fade (marked `.is-inview-initial`) — otherwise above-the-fold content
 * starts blank and looks broken. ScrollOut only animates what's below the fold.
 */
onDocumentReady(() => {
  const targets = Array.from(document.querySelectorAll('[data-scroll]'));
  if (!targets.length) return;

  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  targets.forEach((el) => {
    if (el.getBoundingClientRect().top < viewportHeight) {
      el.classList.add('is-inview-initial');
      el.setAttribute('data-scroll', 'in');
    }
  });

  ScrollOut({
    targets: '[data-scroll]:not(.is-inview-initial)',
    once: true,
    threshold: 0.12,
    offset: 40,
  });
});
